<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><b>Ghost Hunter’s Guide<br/>
  to<br/>
  Seattle and<br/>
  Puget Sound</b></p>
<p class="author">By Jeff Dwyer</p>
<p class="logo1"><img alt="image" src="Images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_9781589805170_Title.vue?1c2c65fe